import { render, staticRenderFns } from "./Subheading.vue?vue&type=template&id=844490a4"
import script from "./Subheading.vue?vue&type=script&lang=js"
export * from "./Subheading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports